/* eslint-disable flowtype/no-types-missing-file-annotation */
/* eslint-disable @typescript-eslint/camelcase */
import React, { FC } from "react";
import { Waypoint } from "react-waypoint";

interface Props {
  eventLabel: string;
  eventAction: string;
}

export const Tracking: FC<Props> = ({ eventAction, eventLabel }) => (
  <Waypoint
    scrollableAncestor={window}
    onEnter={({ previousPosition }) => {
      if (previousPosition === Waypoint.below) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "Interactions",
          event_action: eventAction,
          event_label: eventLabel
        });
      }
    }}
  />
);
